import createComponent, {
  type ElementWithProps
} from '@carvana/merch-components/createComponent';
import cx from 'classnames';

export const TileContainer = createComponent<
  ElementWithProps<{ hasBorder: boolean; hasShadow?: boolean }>
>('div', props => ({
  className: cx(
    'relative h-full overflow-hidden rounded-md md:hover:border md:hover:border-border-default',
    {
      'u:border u:border-border-subtle': props.hasBorder,
      'shadow-sm': props.hasShadow
    }
  )
}));

// Stretched-link pattern: sits above the link (z-10 > z-0) but pointer-events-none
// lets clicks pass through. Interactive children opt back in with pointer-events-auto.
export const TileContentWrapper = createComponent('div', {
  className: `
     pointer-events-none
     relative
     z-10
     grid
     h-full
     w-full
     grid-cols-1
     grid-rows-[184px_1fr]
     overflow-hidden
     rounded-md
     bg-white
     !font-sans
  `
});
